import { useQuery } from "@tanstack/react-query";
import { useFilters } from "../contexts/FiltersContext";
import { loadEstufaData } from "./data";

export function useEstufaData() {
  const { filter } = useFilters();
  return useQuery({
    queryKey: [
      "estufa-data",
      filter.from.toISOString(),
      filter.to.toISOString(),
      filter.seedId,
      filter.deploymentId,
      filter.platformId,
      filter.granularity,
    ],
    queryFn: () => loadEstufaData(filter),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
